module.exports = __webpack_public_path__ + "static/board-16-6be1e8728daadd96baf41e6d4dea5791.jpg";